import React from 'react';
import { Thermometer, Wrench, Building, ClipboardCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: Thermometer,
  title: 'Installation',
  description: 'Daikin/Mitsubishi specialists, bespoke from £100+VAT'
}, {
  icon: Wrench,
  title: 'Maintenance',
  description: '6/12-month contracts with photo reports'
}, {
  icon: Building,
  title: 'FM & Ad-Hoc Support',
  description: 'White-label, in-house support'
}, {
  icon: ClipboardCheck,
  title: 'TM44 Compliance',
  description: '5yr compliance, >12kW, ISO14001-linked'
}];
const highlights = [{
  icon: 'https://cdn.magicpatterns.com/uploads/9RHSsu48RcfwNCQa8fX12h/icon-daikin.svg',
  title: 'Daikin D1+ Partner',
  description: 'Certified premium partner for Daikin air conditioning systems.'
}];
export function Services() {
  return <section className="py-24 bg-[#E8F0F8]" data-id="element-167">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-168">
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-16" data-id="element-169">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-6" data-id="element-170">
              <div className="flex-shrink-0" data-id="element-171">
                <service.icon className="w-8 h-8 text-accent stroke-[1.5]" data-id="element-172" />
              </div>
              <div data-id="element-173">
                <h3 className="text-2xl mb-4" data-id="element-174">{service.title}</h3>
                <p className="text-primary-dark/70 leading-relaxed text-sm" data-id="element-175">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        
      </div>
    </section>;
}